export const PLAN_URL = '/settings/plan';
export const ROOT_ROUTE = '/';
export const USAGE_URL = '/settings/usage';
export const BILLING_URL = '/settings/billing';
